import Manager from "./Manager";
import {FormsManager} from "../index";
import FieldSet from "./FieldSet";

class Form {

  fields = {};
  fieldsets = {};
  config= {}

  constructor(formEl, config) {
    this.formEl = formEl;
    this.config = config;

    this.onSubmit = this.onSubmit.bind(this)
    this.getFormElement().addEventListener('submit', this.onSubmit)

    this.initFields();
    this.initFieldsets();
    this.applyConfig();
    Manager.log('Initialized form:', formEl)
    this.dispatchEvent('init')

  }

  initFieldsets() {
    const fieldsetEls = this.formEl.querySelectorAll('fieldset');
    for (let fieldsetEl of fieldsetEls){
      const fieldset = new FieldSet(this, fieldsetEl);
      for (let [name, field] of Object.entries(this.fields)){
        if (fieldsetEl.contains(field.getContainer())){
          fieldset.addField(name, field)
        }
      }
      this.fieldsets[fieldsetEl.name] = fieldset
    }
  }

  initFields() {
    for (let FieldType of FormsManager.registeredFieldTypes){
      const foundFields = FieldType.findAllFieldsInForm(this.formEl);
      for ( let fieldName of Object.keys(foundFields) ){
        this.fields[fieldName] = new FieldType( this, foundFields[fieldName], (this.config.fields ?? {})[fieldName] ?? {} )
      }
    }
    Manager.log('Fields: ', this.fields);

  }

  applyConfig(){
    if ('events' in this.config ){
      for (let eventName of Object.keys(this.config.events)){
        this.getFormElement().addEventListener(eventName, this.config.events[eventName])
      }
    }
  }

  onSubmit(e) {
    e.preventDefault();
    this.clearFieldErrors();
    this.clearOutput()
    this.setBodyLoading(true);
    this.setLoading(true);

    let formData = new FormData;
    for (let fieldName of Object.keys(this.fields)){
      const field = this.fields[fieldName];
      if (field.getValue() !== undefined){
        if (Array.isArray(field.getValue())){
          for (let value of field.getValue()) formData.append(field.getRawFieldName(), value)
        } else {
          formData.append(field.getFieldName(), field.getValue())
        }
      }
    }
    formData = this.executeHook('formData', formData)
    Manager.log('Data: ', formData.entries());

    const xhr = new XMLHttpRequest()
    xhr.open('POST', this.formEl.action, true)
    xhr.onreadystatechange = () => {
      if (xhr.readyState === XMLHttpRequest.DONE) {

        switch (xhr.status) {
          case 200:
            this.dispatchEvent('beforeSuccess', {xhr})
            this.displayOutput(xhr.responseText)
            if (Manager.clearOnSuccess){
              this.reset()
            }
            this.dispatchEvent('onSuccess', {xhr})
            break
          case 422:
            this.dispatchEvent('beforeValidationError', {xhr})
            let json = JSON.parse(xhr.responseText);
            json = this.executeHook('validationErrors', json)
            for (let fieldName of Object.keys(json)) {
              const existingCorrespondingField = Object.keys(this.fields)
                  .filter(_fieldName => (
                      _fieldName === fieldName ||
                      (new RegExp(_fieldName + '.[0-9]+')).test(fieldName))
                  )[0] ?? null
              if (existingCorrespondingField){
                const field = this.getField(existingCorrespondingField)
                if (field) {
                  field.displayError(json[fieldName].join('. '))
                }
              }
            }
            this.dispatchEvent('onValidationError', {xhr, errors:json})
            break
          case 500:
            this.dispatchEvent('beforeGenericError', {xhr})
            this.displayOutput(xhr.responseText, true)
            this.dispatchEvent('onGenericError', {xhr})
            break;
          default:
            this.dispatchEvent('onUnknownResponseCode', {xhr})
            break;
        }

        this.setBodyLoading(false);
        this.setLoading(false);
      }
    }

    xhr.send(formData)
  }

  getFormElement(){
    return this.formEl;
  }

  getOutputElement(){
    return this.getFormElement().querySelector('.Form__output')
  }

  getSubmitButton(){
    return this.getFormElement().querySelector('button[type=submit]')
  }

  getField(name){
    return this.fields[name];
  }

  getFieldset(name){
    return this.fieldsets[name];
  }

  dispatchEvent(name, data={}){
    Manager.log(`Triggering event [${name}] on form: `, this)
    data.form = this;
    const event = new CustomEvent(name, {detail: data});
    this.getFormElement().dispatchEvent(event);
  }

  executeHook(name, data){
    if ('hooks' in this.config){
      if (name in this.config.hooks){
        Manager.log(`Executing hook [${name}] on form: `, this)
        data = this.config.hooks[name](data)
      }
    }
    return data;
  }

  displayOutput(text, isError = false){
    if (isError) this.getOutputElement().classList.add('--error')
    else this.getOutputElement().classList.remove('--error')
    this.getOutputElement().innerHTML = text;
  }

  clearOutput(){
    this.getOutputElement().classList.remove('--error')
    this.getOutputElement().innerHTML = '';
  }

  clearFieldErrors(){
    for (let field of Object.values(this.fields)) field.clearError()
  }

  reset(){
    this.getFormElement().reset()
  }

  setLoading(loading){
    this.getSubmitButton().disabled = !!loading;
  }

  setBodyLoading(loading){
   if (loading) {
     document.body.classList.add('--loading')
    }
    else {
     document.body.classList.remove('--loading');
    }
  }

  destroy(){

    Manager.log(`Destroying form: `, this)

    /* Remove submit event */
    this.getFormElement().removeEventListener('submit', this.onSubmit)

    /* Remove custom events  */
    if ('events' in this.config ){
      for (let eventName of Object.keys(this.config.events)){
        this.getFormElement().removeEventListener(eventName, this.config.events[eventName])
      }
    }

    for (let fieldName of Object.keys(this.fields)){
      this.fields[ fieldName ].destroy()
    }
  }
}

export default Form;
